const List = ({ children, isGridActive }) => {
    return (
        <div className={`main-list ${isGridActive ? "main-list--grid-view" : ""}`}>
            <div className="main-list__container">
                {children}
            </div>
        </div>
    );
};

export default List;
